import "./Footer.css";
import Logo from "../../assets/images/logo.png";
import GeekBoy from "../UI/GeekBoy/GeekBoy";

const footerDescription = {
  companyName: "k5-Fitness",
  companyLogoUrl: Logo,
  companyDesc:
    "We are simply known for delivering genuine sports nutrition supplements... ",
};

const Footer = (props) => {
  let collapsable;
  let icon;
  if (window.innerWidth < 576) {
    collapsable = "collapse";
    icon = <i className="fa fa-plus" style={{ fontSize: "1rem" }}></i>;
  } else {
    collapsable = "";
    icon = null;
  }
  return (
    <>
      <div style={{ display: "flex", flexDirection: "column" }}></div>
      <div style={{ minHeight: "600px" }}>{props.children}</div>

      <footer id="footer" className="footer-1">
        <div className="main-footer widgets-dark typo-light">
          <div className="container">
            <div className="row">
              <div className="col-xs-12 col-sm-6 col-md-3">
                <div className="widget subscribe no-box">
                  {/* accordian */}
                  <h5
                    className="widget-title"
                    data-toggle={collapsable}
                    href="#company"
                  >
                    {footerDescription.companyName}
                    {icon}
                    <span></span>
                  </h5>
                  <div
                    id="company"
                    className={collapsable + " show"}
                    data-parent="#footer"
                  >
                    <img
                      style={{ width: "5rem" }}
                      src={footerDescription.companyLogoUrl}
                    ></img>
                    <p>{footerDescription.companyDesc}</p>
                  </div>
                </div>
              </div>

              <div className="col-xs-12 col-sm-6 col-md-3">
                <div className="widget no-box">
                  {/* accordian */}
                  <h5
                    className="widget-title"
                    data-toggle={collapsable}
                    href="#links"
                  >
                    Quick Links{icon}
                    <span></span>
                  </h5>
                  <ul
                    className={"thumbnail-widget " + collapsable}
                    data-parent="#footer"
                    id="links"
                  >
                    <li>
                      <div className="thumb-content">
                        <a href="/aboutUs">About Us</a>
                      </div>
                    </li>
                    <li>
                      <div className="thumb-content">
                        <a href="/cookiePolicy">Cookie Policy</a>
                      </div>
                    </li>
                    <li>
                      <div className="thumb-content">
                        <a href="/privacyPolicy">Privacy Policy</a>
                      </div>
                    </li>
                    <li>
                      <div className="thumb-content">
                        <a href="/returnRefundAndCancellation">
                          Return Refund And Cancellation
                        </a>
                      </div>
                    </li>
                    <li>
                      <div className="thumb-content">
                        <a href="/shippingPolicy">Shipping Policy</a>
                      </div>
                    </li>
                    <li>
                      <div className="thumb-content">
                        <a href="/termsAndConditions">Terms And Conditions</a>
                      </div>
                    </li>
                    <li>
                      <div className="thumb-content">
                        <a href="/contactUs">Contact Us</a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-xs-12 col-sm-6 col-md-3">
                <div className="widget no-box">
                  <h5
                    className="widget-title"
                    data-toggle={collapsable}
                    href="#getStarted"
                  >
                    Get Started{icon}
                    <span></span>
                  </h5>
                  <div
                    className={collapsable}
                    data-parent="#footer"
                    id="getStarted"
                  >
                    <a style={{ cursor: "pointer" }} href="/workouts">
                      <p>
                        Get access to your full Training and Marketing Suite.
                      </p>
                    </a>

                    {/* <a className="btn" href="#." target="_blank">
                      Register Now
                    </a> */}
                  </div>
                </div>
              </div>

              <div className="col-xs-12 col-sm-6 col-md-3">
                <div className="widget no-box">
                  <h5
                    className="widget-title"
                    data-toggle={collapsable}
                    href="#contact"
                  >
                    Contact Us{icon}
                    <span></span>
                  </h5>
                  <div
                    className={collapsable}
                    data-parent="#footer"
                    id="contact"
                  >
                    <p>
                      <a href="mailto:info@domain.com" title="glorythemes">
                        info@k5fitnessgears.com
                      </a>
                    </p>
                    {/* <ul className="social-footer2">
                      <li>
                        <span className="material-icons">facebook</span>
                      </li>
                    </ul> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-copyright">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <p>
                  Copyright K5 Fitness &copy; {new Date().getFullYear()}. All
                  rights reserved.
                </p>
              </div>
            </div>
          </div>
          <GeekBoy />
        </div>
      </footer>
    </>
  );
};

export default Footer;
